module.exports = __webpack_public_path__ + "media/images/interface-dropdown-small-f79e9369eccd48f5be748f8bdfcc4b3f.svg";